/* ============================================================================
   mek-cinematic.js   —   Save as:  assets/mek-cinematic.js
   Shared behaviour for all MEK Cinematic sections. Loads ONCE (guarded) and
   only wires up components that are actually present in the DOM, so sections
   can be added, removed, or reordered freely in the customizer.

   Data injected inline by the sections that own it:
     window.MEK_FRAMES = { template: "<url with 0001>", count: 111 }   (scroll-open)
     window.MEK_PLAN   = { id, available, planId, pct, oncePrice,
                           subPrice, freq, def, cartUrl }              (offer / buybar)
   ============================================================================ */
(function () {
  if (window.__mekCinematicInit) return;
  window.__mekCinematicInit = true;
  // Start this page at the top on refresh: restoring a mid-animation scroll position is
  // the state where the pinned sections measure wrong.
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;


  // Diagnostics, only when the address has ?mekdebug=1: a small read-out pinned to the top of the
  // page. Normal visitors never see it. Remove once the phone issue is settled.
  var DBG = /[?&]mekdebug=1/.test(location.search), dbgLog = [], dbgBox = null, dbgStatus = '';
  // Test switch (phones): ?mekbitmaps=1 keeps each frame unpacked in memory, like desktop. Off by default.
  var MEK_BITMAPS = /[?&]mekbitmaps=1/.test(location.search), dbgDraws = 0, dbgDrawMs = 0, dbgDrawMax = 0, dbgCalls = 0;
  function dbgRender() {
    if (!dbgBox) {
      if (!document.body) return;
      dbgBox = document.createElement('pre');
      dbgBox.style.cssText = 'position:fixed;left:6px;right:6px;top:calc(env(safe-area-inset-top,0px) + 6px);z-index:2147483647;margin:0;padding:6px 8px;background:rgba(0,0,0,.85);color:#7CFC9A;font:11px/1.35 Menlo,monospace;white-space:pre-wrap;pointer-events:none;border-radius:6px';
      document.body.appendChild(dbgBox);
    }
    dbgBox.textContent = dbgStatus + '\n' + dbgLog.join('\n');
  }
  function mekDbg(msg) {
    if (!DBG) return;
    dbgLog.push((performance.now() / 1000).toFixed(1) + 's ' + msg);
    if (dbgLog.length > 12) dbgLog.shift();
    dbgRender();
  }
  if (DBG) {
    try {
      if (sessionStorage.getItem('mekdbg-open') === '1') mekDbg('previous visit did not close normally (possible memory reload)');
      sessionStorage.setItem('mekdbg-open', '1');
      addEventListener('pagehide', function () { sessionStorage.removeItem('mekdbg-open'); });
    } catch (e) {}
    addEventListener('error', function (e) {
      var src = e.filename || (e.target && (e.target.currentSrc || e.target.src)) || '';
      if (/mek/.test(src)) mekDbg('ERROR ' + (e.message || 'failed to load') + ' ' + String(src).split('/').pop().split('?')[0]);
    }, true);
    setInterval(function () {
      var need = SPRITE ? Math.ceil(FRAME_COUNT / SPRITE.step) : 0;
      dbgStatus = (matchMedia('(max-width:700px)').matches ? 'phone' : 'desktop') +
        ' | frames ' + tiles.filter(Boolean).length + '/' + need +
        (SPRITE && SPRITE.lo ? ' | stand-ins ' + loTiles.filter(Boolean).length + '/' + Math.ceil(FRAME_COUNT / SPRITE.lo.step) : '') +
        ' | showing ' + lastTile + ' | canvas ' + (scrubCanvas ? scrubCanvas.width + 'x' + scrubCanvas.height : 'none') +
        ' | ' + (MEK_BITMAPS ? 'bitmaps' : 'images') + ' | redraws ' + dbgDraws * 2 + '/s avg ' + (dbgDraws ? (dbgDrawMs / dbgDraws).toFixed(1) : '0') +
        'ms max ' + dbgDrawMax.toFixed(1) + 'ms | updates ' + dbgCalls * 2 + '/s';
      dbgDraws = 0; dbgDrawMs = 0; dbgDrawMax = 0; dbgCalls = 0;
      dbgRender();
    }, 500);
  }
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.async = false;
      s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  ready(boot);

  function boot() {
    if (DBG) { var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0]; mekDbg('page ready' + (nav ? ' (HTML parsed at ' + (nav.domInteractive / 1000).toFixed(1) + 's)' : '')); }
    // These never need GSAP:
    initLenisWhenReady();
    initDust();
    initPlan();
    initATC();

    if (reduced) { staticFallback(); return; }

    // Load the animation stack, then wire the scroll-driven pieces.
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js')
      .then(function () { return loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js'); })
      .then(function () {
        if (!window.gsap) { staticFallback(); return; }
        if (DBG) mekDbg('animation library loaded' + performance.getEntriesByType('resource').filter(function (e) { return /gsap\.min|ScrollTrigger/.test(e.name); }).map(function (e) { return ' | ' + e.name.split('/').pop() + ' ' + (e.startTime / 1000).toFixed(1) + '-' + (e.responseEnd / 1000).toFixed(1) + 's'; }).join(''));
        window.gsap.registerPlugin(window.ScrollTrigger);
        initScrub();
        initManifest();
        initReveals();
        initBuyBarReveal();
        // Re-measure once the page has settled (images, fonts), so the prescriptions pin
        // starts where the opening section actually ends, even after a fast early scroll.
        var refresh = function () { if (window.ScrollTrigger) window.ScrollTrigger.refresh(); };
        if (document.readyState === 'complete') setTimeout(refresh, 0);
        else window.addEventListener('load', refresh, { once: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
      })
      .catch(staticFallback);
  }

  /* ---------- hold the page on the opening until its frames are ready ----------
     Plain JS on purpose: it is active from the first moment of the page, before GSAP or
     smooth scroll have loaded, so nobody can scroll through the opening while it is still
     loading. Releases when the frames are ready and the page has finished loading, or after
     8 seconds at the latest. Blocks wheel/trackpad, touch and the scroll keys directly, and
     stops smooth scroll too if it loads during the hold. */
  function earlyHold() {
    var sec = document.getElementById('mek-act-open');
    var cfg = window.MEK_FRAMES || {};
    if (!sec || !cfg.sprite || reduced) return;
    var root = document.documentElement, held = false, start = 0, done = false;
    function ready() { return window.__mekFramesReady === true && document.readyState === 'complete'; }
    function setHold(on) {
      held = on;
      root.classList.toggle('mek-hold', on);
      var L = window.__mekLenis;
      if (L) { if (on) L.stop(); else L.start(); }
    }
    function block(e) { if (held) e.preventDefault(); }
    addEventListener('wheel', block, { passive: false });
    addEventListener('touchmove', block, { passive: false });
    addEventListener('keydown', function (e) {
      if (held && [32, 33, 34, 35, 36, 38, 40].indexOf(e.keyCode) > -1) e.preventDefault();
    }, { passive: false });
    (function tick() {
      if (done) return;
      if (held) {
        var L = window.__mekLenis;
        if (L && !L.isStopped) L.stop();                    // smooth scroll loaded mid-hold
        if (ready() || Date.now() - start > 8000) { setHold(false); done = true; return; }
      } else if (ready()) {
        done = true; return;
      } else {
        var r = sec.getBoundingClientRect();
        if (r.top <= 0 && r.top > -window.innerHeight * 0.6) {
          var y = window.scrollY + r.top;                   // back to the start of the opening
          if (window.__mekLenis) window.__mekLenis.scrollTo(y, { immediate: true, force: true });
          else window.scrollTo(0, y);
          start = Date.now();
          setHold(true);
        }
      }
      requestAnimationFrame(tick);
    })();
  }

  /* If animation can't run, just make everything visible and pin the poster. */
  function staticFallback() {
    var bar = document.getElementById('mek-buybar');
    if (bar) bar.classList.add('on');
    var poster = document.getElementById('mek-scrub-poster');
    if (poster) poster.style.display = 'block';
    var scrub = document.getElementById('mek-scrub');
    if (scrub) scrub.style.display = 'none';
    document.querySelectorAll('.mek-stat, .mek-rx-card').forEach(function (el) {
      el.style.opacity = '1'; el.style.transform = 'none';
    });
    initBuyBarRevealScrollOnly();
  }

  /* ---------- Lenis smooth scroll (optional) ---------- */
  function initLenisWhenReady() {
    if (reduced) return;
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/lenis/1.1.14/lenis.min.js')
      .then(function () {
        if (typeof Lenis === 'undefined') return;
        var lenis = new Lenis({ duration: 1.15, smoothWheel: true });   // matches the concept HTML
        window.__mekLenis = lenis;
        lenis.on('scroll', function () { if (window.ScrollTrigger) window.ScrollTrigger.update(); });
        // Hand over to GSAP's ticker if it's already loaded; otherwise run our own
        // loop until initScrub attaches it (the loop stops itself at that point).
        if (!attachLenisToTicker()) {
          (function raf(t) { if (window.__mekLenisOnTicker) return; lenis.raf(t); requestAnimationFrame(raf); })();
        }
      })
      .catch(function () {});
  }

  /* ---------- hero dust ---------- */
  function initDust() {
    if (reduced) return;
    var c = document.getElementById('mek-dust');
    if (!c) return;
    var x = c.getContext('2d'), W, H, P = [];
    function size() { W = c.width = c.offsetWidth; H = c.height = c.offsetHeight; }
    size(); addEventListener('resize', size);
    for (var i = 0; i < 70; i++) P.push({ x: Math.random(), y: Math.random(), r: Math.random() * 1.6 + .3, s: Math.random() * .00025 + .00006, o: Math.random() * .5 + .15 });
    (function tick() {
      x.clearRect(0, 0, W, H);
      for (var k = 0; k < P.length; k++) {
        var p = P[k]; p.y -= p.s; if (p.y < 0) p.y = 1;
        x.beginPath(); x.arc(p.x * W, p.y * H, p.r, 0, 7);
        x.fillStyle = 'rgba(124,195,224,' + (p.o * .5) + ')'; x.fill();
      }
      requestAnimationFrame(tick);
    })();
  }

  /* ---------- frame scrub engine ---------- */
  var frames = [], FRAME_COUNT = 0, framesLoaded = 0, firstFrameReady = false;
  var scrubCanvas, sctx, curFrame = 0, frameTemplate = '', frameUrls = null, BLEND = false;
  // Sprite mode: frames are tiles in a few large sheets (window.MEK_FRAMES.sprite).
  // SPRITE = { urls, cols, rows, step }; step 2 = the sheet holds every 2nd frame.
  var SPRITE = null, sheets = [], lastTile = -1, lastBlend = -1;
  // Desktop opening image size + vertical nudge, from the section settings (Layout & spacing).
  var imgScale = 1, imgOffY = 0;
  // Pacing for the 111-frame MEK opening: MEK_PACE[i] = share of the scroll at which
  // frame i shows. Built from the measured change between frames, so equal scroll shows
  // an equal amount of motion (the near-still closed kit is compressed, the lid swing
  // gets most of the scroll). Belongs to this exact sequence: a new render needs a new table.
  var MEK_PACE = [
    0.0,0.003,0.0059,0.0093,0.0124,0.0153,0.0183,0.0214,0.0245,0.0276,
    0.0306,0.0337,0.0367,0.04,0.0433,0.0462,0.0492,0.0523,0.0552,0.0586,
    0.0619,0.0653,0.0683,0.0713,0.0743,0.0774,0.0808,0.0845,0.0875,0.0906,
    0.0937,0.0971,0.1007,0.1041,0.1074,0.1108,0.1143,0.1181,0.1218,0.1254,
    0.1288,0.1325,0.136,0.1396,0.1433,0.1469,0.1505,0.1541,0.1579,0.1618,
    0.1657,0.1699,0.1739,0.1781,0.1823,0.1864,0.1908,0.1948,0.199,0.2039,
    0.2085,0.2135,0.2192,0.2255,0.232,0.2394,0.2477,0.2567,0.2661,0.2756,
    0.2859,0.2967,0.3085,0.3207,0.3333,0.3468,0.3618,0.3774,0.3941,0.4117,
    0.4303,0.4491,0.4687,0.4884,0.5082,0.5294,0.5508,0.5699,0.5881,0.6065,
    0.624,0.6412,0.6597,0.6788,0.7016,0.7231,0.7454,0.7694,0.7932,0.8155,
    0.8358,0.855,0.8736,0.8913,0.9085,0.9253,0.9419,0.9575,0.9723,0.9864,
    1.0
  ];
  // Desktop: frames straight through, as in the concept. Phones keep the pacing table, so the near-still
  // closed kit no longer takes most of the scroll and the lid swing gets room (phones only).
  if (!matchMedia('(max-width:700px)').matches) MEK_PACE = [];
  function frameAtProgress(p) {
    var lo = 0, hi = MEK_PACE.length - 1;
    if (p <= 0) return 0;
    if (p >= 1) return hi;
    while (hi - lo > 1) { var mid = (lo + hi) >> 1; if (MEK_PACE[mid] <= p) lo = mid; else hi = mid; }
    return lo + (p - MEK_PACE[lo]) / (MEK_PACE[hi] - MEK_PACE[lo]);
  }

  function getFrameSrc(i) {
    if (frameUrls) return frameUrls[i];
    return frameTemplate.replace('0001', String(i + 1).padStart(4, '0'));
  }

  // Sprite tile number k (0 = first tile) -> { k, img, x, y, w, h }, or null if its sheet isn't loaded.
  var tiles = [];   // per-frame bitmaps cut from the sheets (small images draw like the concept's frames)
  function spriteTileK(k) {
    var per = SPRITE.cols * SPRITE.rows;
    var last = Math.ceil(FRAME_COUNT / SPRITE.step) - 1;
    k = Math.min(last, Math.max(0, k));
    if (tiles[k]) return { k: k, img: tiles[k], x: 0, y: 0, w: tiles[k].width, h: tiles[k].height };
    // Sharp frame not cut yet: use the phone-sheet stand-in, or null (the caller holds the last
    // frame). Never draw straight from a raw sheet: every such draw unpacks the whole sheet again.
    return loTile(k);
  }
  // Frame index -> nearest tile.
  function spriteTile(idx) { return spriteTileK(Math.round(idx / SPRITE.step)); }

  // Drive Lenis from GSAP's ticker so smooth scroll and the scrubbed timeline
  // update on the same frame (Lenis's recommended setup; removes pin jitter).
  function attachLenisToTicker() {
    if (window.__mekLenisOnTicker) return true;
    var L = window.__mekLenis, g = window.gsap;
    if (!L || !g || !g.ticker) return false;
    window.__mekLenisOnTicker = true;
    g.ticker.add(function (time) { L.raf(time * 1000); });
    g.ticker.lagSmoothing(0);
    return true;
  }

  function sizeCanvas() {
    if (!scrubCanvas) return;
    var dpr = Math.min(devicePixelRatio || 1, 2);
    scrubCanvas.width = scrubCanvas.offsetWidth * dpr;
    scrubCanvas.height = scrubCanvas.offsetHeight * dpr;
    drawFrameF(curFrame, true);
  }
  // r = optional source rectangle { x, y, w, h } (sprite tile); default = whole image.
  function placeImg(img, r) {
    sctx.imageSmoothingEnabled = true; sctx.imageSmoothingQuality = 'high';   // frames are scaled up on retina; default quality is 'low'
    var cw = scrubCanvas.width, ch = scrubCanvas.height;
    var mobile = matchMedia('(max-width:700px)').matches;
    var wide = matchMedia('(min-width:1100px)').matches;
    var portrait = ch > cw;
    var maxW, maxH, cx, cy;
    if (mobile) { maxW = cw * 0.92; maxH = ch * 0.90; cx = cw * 0.5; cy = ch * 0.5; }
    else if (wide) { maxW = cw * 0.92 * imgScale; maxH = ch * 0.86 * imgScale; cx = cw * 0.60; cy = ch * (0.53 + imgOffY); }
    else if (portrait) { maxW = cw * 0.94; maxH = ch * 0.62; cx = cw * 0.5; cy = ch * 0.40; }
    else { maxW = cw * 0.86; maxH = ch * 0.76; cx = cw * 0.5; cy = ch * 0.50; }
    var sw = r ? r.w : img.width, sh = r ? r.h : img.height;
    var s = Math.min(maxW / sw, maxH / sh);
    var w = sw * s, h = sh * s;
    if (r) sctx.drawImage(img, r.x, r.y, r.w, r.h, cx - w / 2, cy - h / 2, w, h);
    else sctx.drawImage(img, cx - w / 2, cy - h / 2, w, h);
  }
  // Fractional frame position. Cross-fades neighbours when BLEND (few uploaded
  // frames); nearest-frame for long pre-rendered sequences and sprite sheets.
  function drawFrameF(f, force) {
    if (!sctx) return;
    f = Math.max(0, Math.min(FRAME_COUNT - 1, f));
    var cw = scrubCanvas.width, ch = scrubCanvas.height;
    if (SPRITE && SPRITE.frames) {
      // Phones (one image per frame): blend each frame into the next by the in-between scroll
      // position, so the picture moves every screen refresh instead of jumping frame to frame.
      // With all 111 frames the neighbours are close, so the blend reads as motion, not a ghost.
      // While frames are still arriving, blend between the nearest loaded frames on either side,
      // so the opening already moves smoothly with the coarse set and sharpens as the rest land.
      var fk = f / SPRITE.step, lastK = Math.ceil(FRAME_COUNT / SPRITE.step) - 1, key = Math.round(fk * 100);
      var L = Math.min(lastK, Math.floor(fk)), H = L + 1, t = 0;
      while (L >= 0 && !tiles[L]) L--;
      while (H <= lastK && !tiles[H]) H++;
      var a0 = L >= 0 ? spriteTileK(L) : null, a1 = H <= lastK ? spriteTileK(H) : null;
      if (a0 && a1) t = Math.min(1, Math.max(0, (fk - L) / (H - L)));
      else if (!a0) { a0 = a1; a1 = null; }
      if (t <= 0.01) a1 = null;
      var ldp = document.getElementById('mek-scrub-loader');
      if (ldp) ldp.style.opacity = a0 ? '0' : '.85';
      if (DBG) dbgCalls++;
      if (a0 && (force || key !== lastBlend)) {
        var dt0 = DBG ? performance.now() : 0;
        sctx.globalAlpha = 1; sctx.fillStyle = '#FFFFFF'; sctx.fillRect(0, 0, cw, ch);
        placeImg(a0.img, a0);
        if (a1 && a1.k !== a0.k) { sctx.globalAlpha = t; placeImg(a1.img, a1); sctx.globalAlpha = 1; }
        lastTile = a0.k; lastBlend = key;
        if (DBG) { var dd = performance.now() - dt0; dbgDraws++; dbgDrawMs += dd; if (dd > dbgDrawMax) dbgDrawMax = dd; }
      }
      curFrame = f;
      return;
    }
    if (SPRITE) {
      // Nearest tile only. Cross-fading two fast-moving frames ghosts the lid.
      var a = spriteTileK(Math.round(f / SPRITE.step));
      var ld = document.getElementById('mek-scrub-loader');
      if (ld) ld.style.opacity = a ? '0' : '.85';            // say so while this part is still loading
      if (!a && lastTile >= 0) a = spriteTileK(lastTile);   // sheet still loading: hold the last frame
      if (a && (force || a.k !== lastTile)) {             // redraw only when the tile changes
        sctx.fillStyle = '#FFFFFF'; sctx.fillRect(0, 0, cw, ch);
        placeImg(a.img, a);
        lastTile = a.k;
      }
      curFrame = f;
      return;
    }
    sctx.fillStyle = '#FFFFFF'; sctx.fillRect(0, 0, cw, ch);
    if (BLEND) {
      var i0 = Math.floor(f), i1 = Math.min(FRAME_COUNT - 1, i0 + 1), t = f - i0;
      var a = frames[i0], b = frames[i1];
      if (a && a.complete) { sctx.globalAlpha = 1; placeImg(a); }
      if (b && b.complete && i1 !== i0 && t > 0) { sctx.globalAlpha = t; placeImg(b); sctx.globalAlpha = 1; }
    } else {
      var idx = Math.round(f);
      var img = frames[idx] || frames[Math.round(curFrame)] || frames[0];
      if (img && img.complete) placeImg(img);
    }
    curFrame = f;
  }
  function drawFrame(i, force) { drawFrameF(i, force); } // back-compat

  // Cut a loaded sheet into one small bitmap per frame, then let the big sheet go. Drawing a
  // small image per frame is what keeps the concept HTML smooth; drawing out of a 17-megapixel
  // sheet makes the browser move the whole sheet to the graphics card.
  function sliceSheet(i, img) {
    if (SPRITE.frames) {                                     // phones, one image per frame: use it as is
      var use = function () {
        if (!img.naturalWidth) return;
        if (MEK_BITMAPS && window.createImageBitmap) {           // test switch: keep the frame unpacked
          createImageBitmap(img).then(function (b) { tiles[i] = b; sheets[i] = null; drawFrameF(curFrame, true); },
            function () { tiles[i] = img; drawFrameF(curFrame, true); });
        } else { tiles[i] = img; sheets[i] = null; drawFrameF(curFrame, true); }
      };
      if (img.decode) img.decode().then(use, use); else use();
      if (i === 0 || i === SPRITE.urls.length - 1) mekDbg('frame ' + (i + 1) + ' of ' + SPRITE.urls.length + ' loaded');
      return;
    }
    if (!SPRITE.lo && matchMedia('(max-width:700px)').matches) { queueCut(i, img); return; }   // phones only
    sliceInto(img, SPRITE, i, tiles, function () { sheets[i] = null; drawFrameF(curFrame, true); });
  }
  // Phones only: cut the sheets one at a time, in playback order, so the start of the opening is
  // ready first instead of both sheets competing for the phone. Desktop never comes here.
  var cutQueue = [], cutNext = 0, cutBusy = false;
  function queueCut(i, img) {
    mekDbg(String(img.currentSrc || img.src).split('/').pop().split('?')[0] + ': downloaded');
    cutQueue[i] = img;
    pumpCut();
  }
  function pumpCut() {
    if (cutBusy || !cutQueue[cutNext]) return;
    var i = cutNext++, img = cutQueue[i];
    cutQueue[i] = null; cutBusy = true;
    var next = function () { cutBusy = false; pumpCut(); };
    var p = sliceInto(img, SPRITE, i, tiles, function () { sheets[i] = null; drawFrameF(curFrame, true); });
    if (p) p.then(next, next); else next();
  }

  // Low-res stand-in from the small phone sheets (every 2nd frame), used on desktop until the
  // sharp sheet for that frame has arrived. Same picture, a little softer.
  var loTiles = [], loSheets = [];
  function loTile(k) {
    var L = SPRITE && SPRITE.lo; if (!L) return null;
    var j = Math.min(Math.ceil(FRAME_COUNT / L.step) - 1, Math.round(k * SPRITE.step / L.step));
    if (loTiles[j]) return { k: k, img: loTiles[j], x: 0, y: 0, w: loTiles[j].width, h: loTiles[j].height };
    return null;   // not cut yet: the caller holds the last frame
  }
  // Unpack a downloaded sheet ONCE. Re-reading the file (served from the browser cache) and
  // decoding it from data lets the browser unpack it off the main thread. Cutting frames straight
  // from the <img> unpacked the whole sheet again for every frame in Chrome (28 times per phone
  // sheet), which froze the page for seconds on first load. Rejects when the browser can't hold
  // the whole sheet as one image (iPhones cap a single image at about 16.8 million pixels).
  function decodeSheet(img) {
    if (!window.fetch || !window.Blob) return Promise.reject(new Error('fetch unavailable'));
    return fetch(img.currentSrc || img.src)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); })
      .then(function (b) { return createImageBitmap(b); });
  }
  // Cut a sheet into one small bitmap per frame. Fast path: from the unpacked whole sheet (a plain
  // copy per frame). Fallback when that fails: each frame straight from the <img>, the method used
  // before, which only ever creates frame-sized images.
  function sliceInto(img, S, i, store, after) {
    if (!window.createImageBitmap || !img.naturalWidth) return;
    var per = S.cols * S.rows, total = Math.ceil(FRAME_COUNT / S.step);
    var name = String(img.currentSrc || img.src).split('/').pop().split('?')[0];
      mekDbg(name + ': cutting started');
    function cut(src, sw, sh) {
      var w = sw / S.cols, h = sh / S.rows, jobs = [];
      for (var c = 0; c < per; c++) {
        var k = i * per + c; if (k >= total) break;
        jobs.push((function (k, c) {
          return createImageBitmap(src, (c % S.cols) * w, Math.floor(c / S.cols) * h, w, h)
            .then(function (b) { store[k] = b; });
        })(k, c));
      }
      return Promise.all(jobs);
    }
    return decodeSheet(img).then(function (sheet) {
      var size = sheet.width + 'x' + sheet.height;
      mekDbg(name + ': unpacked ' + size);
      return cut(sheet, sheet.width, sheet.height).then(function () {
        if (sheet.close) sheet.close();
        mekDbg(name + ': cut from whole sheet ' + size);
      });
    }).catch(function (e) {
      mekDbg(name + ': whole sheet failed (' + (e && (e.name + ' ' + e.message)) + '), cutting frame by frame');
      return cut(img, img.naturalWidth, img.naturalHeight).then(function () { mekDbg(name + ': cut frame by frame'); });
    }).then(after, function (e) {
      mekDbg(name + ': cutting FAILED (' + (e && (e.name + ' ' + e.message)) + ')');
    });
  }

  function hideLoader() { var l = document.getElementById('mek-scrub-loader'); if (l) l.style.opacity = '0'; }

  function loadFrames() {
    if (SPRITE) {
      // Sheets load one at a time, in playback order, once the page itself has
      // finished loading, so the animation never competes with the hero. Each
      // sheet is decoded before the next starts. Until sheet 1 arrives, the
      // opening image (already on the page, same shot as frame 1) stands in.
      var first = (window.MEK_FRAMES && window.MEK_FRAMES.urls && window.MEK_FRAMES.urls[0]) || null;
      if (first) {
        var ph = new Image();
        ph.onload = function () {
          if (lastTile < 0 && sctx) { sctx.fillStyle = '#FFFFFF'; sctx.fillRect(0, 0, scrubCanvas.width, scrubCanvas.height); placeImg(ph); }
          // The opening frame is painted (white backdrop + kit), so the section is
          // readable now — clear the loader and let the sharp sheets stream in behind.
          hideLoader();
        };
        ph.onerror = function () {
          // Opening image unavailable: show the static poster so this is never a blank panel.
          var p = document.getElementById('mek-scrub-poster');
          if (p) { p.style.display = 'block'; p.style.cssText += ';position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:0'; }
          if (scrubCanvas) scrubCanvas.style.display = 'none';
          hideLoader();
        };
        ph.src = first;
      }
      var next = 0;
      function loadNext() {
        if (next >= SPRITE.urls.length) return;
        var i = SPRITE.order ? SPRITE.order[next++] : next++, img = new Image();
        img.decoding = 'async';
        function done() {
          framesLoaded++;
          if (i === 0) { firstFrameReady = true; hideLoader(); }
          drawFrameF(curFrame, true);
          sliceSheet(i, img);
          loadNext();
        }
        img.onload = done;
        img.onerror = done;
        img.src = SPRITE.urls[i];
        sheets[i] = img;
      }
      // Start when the page has loaded, or after 1.5s at the latest (third-party
      // scripts can hold the load event back), and keep two sheets downloading at once.
      // Start right away with three downloads in flight: on desktop the frames matter more
      // than anything below the hero, and waiting for the page's load event cost seconds.
      // Desktop: the two small phone sheets go first, so the whole animation can play within a
      // second or so; the sharp sheets then stream in behind and replace them frame by frame.
      var LO = SPRITE.lo;
      if (LO) {
        var loLeft = LO.urls.length;
        var startSharp = function () { if (--loLeft === 0) { loadNext(); loadNext(); loadNext(); } };
        LO.urls.forEach(function (u, i) {
          var img = new Image();
          img.decoding = 'async';
          function loDone() {
            if (i === 0) hideLoader();
            sliceInto(img, LO, i, loTiles, function () { loSheets[i] = null; drawFrameF(curFrame, true); });
            drawFrameF(curFrame, true);
            startSharp();
          }
          img.onload = loDone;
          img.onerror = startSharp;
          img.src = u;
          loSheets[i] = img;
        });
      } else {
        loadNext(); loadNext(); loadNext();
        if (SPRITE.frames) { loadNext(); loadNext(); loadNext(); }   // phone frames are small: six at once
      }
      return;
    }

    var many = FRAME_COUNT > 30;
    var stride = (many && matchMedia('(max-width:700px)').matches) ? 2 : 1;
    for (var i = 0; i < FRAME_COUNT; i += (i === 0 ? 1 : stride)) {
      (function (idx) {
        var img = new Image();
        img.onload = function () {
          framesLoaded++;
          if (!firstFrameReady) { firstFrameReady = true; drawFrameF(curFrame, true); }
          var need = Math.floor(FRAME_COUNT / stride) - 1;
          if (framesLoaded >= need) hideLoader();
        };
        img.src = getFrameSrc(idx);
        frames[idx] = img;
        if (stride === 2 && idx > 0 && idx + 1 < FRAME_COUNT) frames[idx + 1] = img;
      })(i);
    }
  }

  function initScrub() {
    attachLenisToTicker();
    scrubCanvas = document.getElementById('mek-scrub');
    var openSec = document.getElementById('mek-act-open');
    if (!scrubCanvas || !openSec) return;
    var cfg = window.MEK_FRAMES || {};
    imgScale = parseFloat(cfg.scale) || 1;
    imgOffY = (parseFloat(cfg.offsetVh) || 0) / 100;
    if (cfg.urls) cfg.urls = cfg.urls.filter(function (u) { return !!u; });
    // Source priority: sprite sheets > per-stat images > numbered sequence (theme assets).
    var seqCount = parseInt(cfg.count, 10) || 0;
    var spriteSet = cfg.sprite ? (matchMedia('(max-width:700px)').matches ? cfg.sprite.m : cfg.sprite.d) : null;
    var useSeq = false;
    if (spriteSet && spriteSet.urls && spriteSet.urls.length && seqCount >= 2) {
      SPRITE = { urls: spriteSet.urls, cols: spriteSet.cols, rows: spriteSet.rows, step: spriteSet.step || 1 };
      // Desktop: the small phone sheets (every 2nd frame) load first as a stand-in.
      if (spriteSet === cfg.sprite.d && cfg.sprite.m && cfg.sprite.m.urls && cfg.sprite.m.urls.length) {
        SPRITE.lo = { urls: cfg.sprite.m.urls, cols: cfg.sprite.m.cols, rows: cfg.sprite.m.rows, step: cfg.sprite.m.step || 2 };
      }
      // Phones: one small image per frame instead of sheets, so nothing has to be unpacked or cut
      // (the sheets took about 12 seconds on an iPhone). Desktop never comes here.
      if (spriteSet === cfg.sprite.m && cfg.sprite.p && cfg.sprite.p.urls && cfg.sprite.p.urls.length) {
        SPRITE = { urls: cfg.sprite.p.urls, cols: 1, rows: 1, step: cfg.sprite.p.step || cfg.sprite.m.step || 2, frames: true };
        // Load coarse to fine (every 16th frame, then every 8th, 4th, 2nd, then the rest), so the whole
        // opening can play from the first second and fills in detail as the rest arrive.
        var order = [], seen = {}, nF = SPRITE.urls.length;
        [16, 8, 4, 2, 1].forEach(function (s) { for (var q = 0; q < nF; q += s) if (!seen[q]) { seen[q] = 1; order.push(q); } });
        if (!seen[nF - 1]) order.splice(1, 0, nF - 1);
        else { order.splice(order.indexOf(nF - 1), 1); order.splice(1, 0, nF - 1); }
        SPRITE.order = order;
      }
      FRAME_COUNT = seqCount; useSeq = true;
    } else if (cfg.urls && cfg.urls.length >= 2) {
      frameUrls = cfg.urls.slice(); FRAME_COUNT = frameUrls.length;
    } else if (cfg.template && seqCount >= 2) {
      frameTemplate = cfg.template; FRAME_COUNT = seqCount; useSeq = true;
    } else {
      FRAME_COUNT = 0;
    }
    if (FRAME_COUNT < 2) {                 // not enough frames to animate: show poster
      var poster = document.getElementById('mek-scrub-poster');
      if (poster) poster.style.display = 'block';
      scrubCanvas.style.display = 'none';
      return;
    }
    BLEND = !SPRITE && FRAME_COUNT <= 30;  // cross-fade a small uploaded set; crisp scrub otherwise

    frames = new Array(FRAME_COUNT);
    sctx = scrubCanvas.getContext('2d', { alpha: false });
    sizeCanvas(); addEventListener('resize', sizeCanvas);
    loadFrames();
    mekDbg('opening set up');

    var gsap = window.gsap;
    var statSel = ['#mek-stat1', '#mek-stat2', '#mek-stat3'].filter(function (s) { return document.querySelector(s); });
    var numStats = statSel.length;

    // Snap slots: slot 0 = opening frame, then one slot per stat. With a full
    // sequence each stat lands on the frame its image is named after (cfg.stops,
    // e.g. mek-open-0081 = frame 81); otherwise the slots are spaced evenly.
    var pos = [];
    for (var s = 0; s < numStats; s++) {
      var p = (s + 1) / numStats;
      var stop = cfg.stops ? parseInt(cfg.stops[s], 10) : 0;
      if (useSeq && stop >= 1 && stop <= FRAME_COUNT) p = (MEK_PACE.length === FRAME_COUNT) ? MEK_PACE[stop - 1] : (stop - 1) / (FRAME_COUNT - 1);
      pos.push(p);
    }

    // --- Text cadence (decoupled from the image frames) ----------------------
    // The stats are the resting states of the section: stat 1 reads at the very
    // top with the overline (no scroll needed), then each step cross-fades to the
    // next. The image keeps scrubbing the full opening underneath, so the kit
    // still plays from closed -> open while the text advances one stat per step.
    var slots = [];
    for (var si = 0; si < numStats; si++) slots.push(numStats > 1 ? si / (numStats - 1) : 0);
    var swap = [];                                    // midpoint where one stat hands to the next
    for (var sj = 0; sj < numStats - 1; sj++) swap.push((slots[sj] + slots[sj + 1]) / 2);
    var gap = numStats > 1 ? 1 / (numStats - 1) : 1;
    var txFade = gap * 0.42;                           // desktop cross-fade length (progress units)
    var txFadeM = gap * 0.26;                           // phones: a touch quicker

    var mobile = matchMedia('(max-width:700px)').matches;
    var wide = matchMedia('(min-width:1101px)').matches;
    var cs = getComputedStyle(openSec);
    var lenVh = parseFloat(mobile ? cs.getPropertyValue('--mek-open-h-m') : cs.getPropertyValue('--mek-open-h')) || (mobile ? 300 : 360);
    // Phones: GSAP pins the stage (a mobile theme wrapper can block CSS sticky).
    // Desktop: CSS sticky holds the stage, and the timeline is driven straight from the section's
    // on-screen position every frame, the way the Foose reveal works. Nothing is measured ahead
    // of time, so a late layout shift, a refresh or a fast early scroll can't leave it stale.
    var openTL;
    // Phones use the same sticky stage and scroll-following as desktop wherever the browser supports
    // overflow: clip (the CSS swaps the theme's html/body overflow-x: hidden for clip so sticky works).
    // Older phones without it keep the GSAP pin below.
    var phoneSticky = mobile && !!(window.CSS && CSS.supports && CSS.supports('overflow', 'clip'));
    if (mobile && !phoneSticky) {
      var stConf = {
        trigger: '#mek-open-stage', start: 'top top',
        end: function () { return '+=' + (window.innerHeight * Math.max(100, lenVh - 100) / 100); },
        pin: true, pinSpacing: true, anticipatePin: 0,
        scrub: SPRITE ? 0.1 : 1, invalidateOnRefresh: true   // phones: follow the finger closely (was 0.5 s behind)
      };
      if (numStats > 0 && !SPRITE) {
        stConf.snap = { snapTo: slots, duration: { min: 0.3, max: 0.8 }, delay: 0.04, ease: 'power2.inOut' };
      }
      openTL = gsap.timeline({ scrollTrigger: stConf });
    } else {
      openTL = gsap.timeline({ paused: true });
      var drive = 0, lastT = 0;
      gsap.ticker.add(function (time) {
        var dt = lastT ? Math.min(0.5, time - lastT) : 1 / 60; lastT = time;
        var r = openSec.getBoundingClientRect(), total = r.height - window.innerHeight;
        var target = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        // Desktop follows tightly (0.075 s). Phones glide (0.18 s, close to the dev page's GSAP scrub of 0.5 s),
        // which smooths over the bursts in which iOS delivers scroll positions on a busy page.
        drive += (target - drive) * (1 - Math.exp(-dt / (phoneSticky ? 0.18 : 0.075)));
        if (Math.abs(target - drive) < 0.0005) drive = target;
        if (openTL.progress() !== drive) openTL.progress(drive);
      });
    }

    openTL.to('#mek-open-stage', {
      backgroundColor: '#FFFFFF', duration: .05,
      onStart: function () { document.body.classList.add('mek-light-mode'); },
      onReverseComplete: function () { document.body.classList.remove('mek-light-mode'); }
    }, 0);

    // Overline stays with the heading the whole way through (the stats accumulate below).
    openTL.set('#mek-open-eyebrow', { opacity: 1 }, 0);

    // linear frame scrub across the whole timeline
    // scroll progress -> frame, through the pacing table when it matches this sequence
    var usePace = useSeq && MEK_PACE.length === FRAME_COUNT;
    var scrubState = { p: 0 };
    openTL.to(scrubState, { p: 1, ease: 'none', duration: 1, onUpdate: function () {
      drawFrameF(usePace ? frameAtProgress(scrubState.p) : scrubState.p * (FRAME_COUNT - 1));
    } }, 0);

    // Stats are not animated at all. They're shown from the start (CSS) and stay
    // exactly as they are the whole way through; the scroll only drives the kit opening.

    openTL.to('#mek-open-stage', { backgroundColor: '#EBF2F4', duration: .06 }, 0.94);

    // Tell the early hold (earlyHold, set up at page start) when every frame has been cut into
    // its own small image: the cutting is heavy one-off work, so it happens during the hold.
    if (SPRITE) {
      gsap.ticker.add(function () {
        if (window.__mekFramesReady) return;
        window.__mekFramesReady = tiles.filter(Boolean).length >= Math.ceil(FRAME_COUNT / SPRITE.step)
          || (!window.createImageBitmap && framesLoaded >= SPRITE.urls.length);
      });
    }
  }


  /* ---------- manifest ---------- */
  function initManifest() {
    var sec = document.getElementById('mek-act-manifest');
    if (!sec) return;
    var gsap = window.gsap;
    var cards = gsap.utils.toArray('.mek-rx-card');
    if (!cards.length) return;
    var N = cards.length;
    var rxCount = document.getElementById('mek-rx-count');
    var rail = document.getElementById('mek-rail-fill');

    var mMobile = matchMedia('(max-width:700px)').matches;
    var perStep = mMobile ? 55 : 65;               // vh of scroll allotted per card
    var mTL;
    // Phones use the same sticky stage and scroll-following as desktop wherever overflow: clip is supported
    // (same reason as the opening: the GSAP pin drifts on phones). Older phones keep the pin.
    var mSticky = mMobile && !!(window.CSS && CSS.supports && CSS.supports('overflow', 'clip'));
    if (mMobile && !mSticky) {
      mTL = gsap.timeline({
        scrollTrigger: {
          trigger: '#mek-manifest-stage', start: 'top top',
          end: function () { return '+=' + (window.innerHeight * (N * perStep) / 100); },
          pin: true, pinSpacing: true, anticipatePin: 0,
          scrub: .5, invalidateOnRefresh: true,
          onUpdate: function (self) { if (rail) rail.style.height = (self.progress * 100) + '%'; }
        }
      });
    } else {
      // Desktop: CSS sticky holds the stage and the timeline follows the section's real position
      // every frame, like the opening. No GSAP pin, so nothing can stay stuck to the screen.
      sec.style.height = (100 + N * perStep) + 'vh';
      mTL = gsap.timeline({ paused: true });
      var mDrive = 0, mLastT = 0;
      gsap.ticker.add(function (time) {
        var dt = mLastT ? Math.min(0.5, time - mLastT) : 1 / 60; mLastT = time;
        var r = sec.getBoundingClientRect(), total = r.height - window.innerHeight;
        var target = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        mDrive += (target - mDrive) * (1 - Math.exp(-dt / (mSticky ? 0.18 : 0.075)));   // phones glide like the opening
        if (Math.abs(target - mDrive) < 0.0005) mDrive = target;
        if (mTL.progress() !== mDrive) {
          mTL.progress(mDrive);
          if (rail) rail.style.height = (mDrive * 100) + '%';
        }
      });
    }
    var seg = 1 / N;
    var exploded = document.getElementById('mek-exploded-img');
    if (exploded) {
      mTL.fromTo('#mek-exploded-img', { scale: 1.0, y: 12 }, { scale: 1.04, y: -12, ease: 'none', duration: 1 }, 0);
    }
    cards.forEach(function (card, i) {
      var t0 = i * seg;
      mTL.call(function () { if (rxCount) rxCount.textContent = 'RX ' + (i + 1) + ' of ' + N; }, [], t0 + seg * 0.12);
      mTL.fromTo(card, { opacity: 0, y: 46 }, { opacity: 1, y: 0, duration: seg * .30 }, t0);
      if (i < N - 1) mTL.to(card, { opacity: 0, y: -40, duration: seg * .26 }, t0 + seg * .72);
    });
  }
  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---------- generic section reveals ---------- */
  function initReveals() {
    var gsap = window.gsap;
    gsap.utils.toArray('.mek-section .mek-inner').forEach(function (el) {
      gsap.fromTo(el, { opacity: 0, y: 44 }, {
        opacity: 1, y: 0, duration: 1, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 78%' }
      });
    });
  }

  /* ---------- buy bar reveal ---------- */
  function initBuyBarReveal() {
    var bar = document.getElementById('mek-buybar'); if (!bar) return;
    var openEl = document.getElementById('mek-act-open');
    if (openEl && window.ScrollTrigger) {
      window.ScrollTrigger.create({
        trigger: '#mek-act-open', start: 'top 60%',
        onEnter: function () { bar.classList.add('on'); },
        onLeaveBack: function () { bar.classList.remove('on'); }
      });
    } else {
      initBuyBarRevealScrollOnly();
    }
  }
  function initBuyBarRevealScrollOnly() {
    var bar = document.getElementById('mek-buybar'); if (!bar) return;
    if (bar.__mekScrollBound) return; bar.__mekScrollBound = true;
    function onScroll() {
      if (window.scrollY > window.innerHeight * 0.6) bar.classList.add('on');
      else bar.classList.remove('on');
    }
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- plan picker (one-time vs subscribe) ---------- */
  function initPlan() {
    var PLAN = window.MEK_PLAN;
    var picker = document.getElementById('mek-plan-picker');
    var bar = document.getElementById('mek-bar-plan');

    // No commerce data at all -> nothing to wire.
    if (!PLAN) { if (picker) picker.remove(); if (bar) bar.remove(); return; }

    window.__mekPlanState = { state: (PLAN.def === 'onetime' ? 'onetime' : 'subscribe'), id: PLAN.planId };

    // No selling plan available -> force one-time and strip the toggles.
    if (!PLAN.planId || !PLAN.subPrice) {
      if (picker) picker.remove();
      if (bar) bar.remove();
      window.__mekPlanState.state = 'onetime';
      window.__mekPlanState.id = null;
    } else {
      var pct = document.getElementById('mek-plan-pct'); if (pct) pct.textContent = PLAN.pct;
      var once = document.getElementById('mek-plan-once'); if (once) once.textContent = PLAN.oncePrice;
      var sub = document.getElementById('mek-plan-sub'); if (sub) sub.textContent = PLAN.subPrice;
      var freq = document.getElementById('mek-plan-freq'); if (freq) freq.textContent = PLAN.freq || 'Recurring delivery';
      if (bar) { bar.hidden = false; var bp = bar.querySelector('.mek-bp-pct'); if (bp) bp.textContent = PLAN.pct; }
    }

    var opts = document.querySelectorAll('.mek-plan-opt, .mek-bp-opt');
    function apply() {
      opts.forEach(function (o) { o.classList.toggle('sel', o.dataset.plan === window.__mekPlanState.state); });
      var price = window.__mekPlanState.state === 'subscribe' ? PLAN.subPrice : PLAN.oncePrice;
      document.querySelectorAll('#mek-buybar .mek-bb-price, .mek-price-live').forEach(function (e) { e.textContent = price; });
    }
    opts.forEach(function (o) {
      o.addEventListener('click', function () { window.__mekPlanState.state = o.dataset.plan; apply(); });
    });
    apply();
  }

  /* ---------- Add to Cart (Shopify AJAX) ---------- */
  function initATC() {
    var PLAN = window.MEK_PLAN || {};
    var buttons = document.querySelectorAll('.mek-atc');
    if (!buttons.length) return;
    var toast = document.getElementById('mek-toast');
    var cartUrl = PLAN.cartUrl || '/cart';

    function showToast(html, ok) {
      if (!toast) return;
      toast.innerHTML = html;
      toast.style.background = ok ? 'rgba(19,111,153,.95)' : 'rgba(150,60,60,.95)';
      toast.classList.add('on');
      setTimeout(function () { toast.classList.remove('on'); }, 6000);
    }

    if (!PLAN.id || PLAN.available === false) {
      buttons.forEach(function (btn) { btn.disabled = true; btn.textContent = PLAN.id ? 'Sold out' : 'Unavailable'; });
      return;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var orig = btn.innerHTML;          // keep the .mek-price-live span intact
        btn.textContent = 'Adding…';
        var st = window.__mekPlanState || { state: 'onetime', id: null };
        var body = { id: PLAN.id, quantity: 1 };
        if (st.state === 'subscribe' && st.id) body.selling_plan = st.id;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
          // Open the theme's side cart (TWC redirects /cart to the home page).
          if (typeof openCartDrawer === 'function') {
            var drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.setAttribute('data-lenis-prevent', '');   // let the drawer scroll natively over Lenis
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              if (typeof updateBubbleCartCount === 'function') updateBubbleCartCount(c.item_count);
            }).catch(function () {});
            openCartDrawer(btn);
          } else {
            showToast('Added to cart \u2713 <a href="' + cartUrl + '">View cart</a>', true);
          }
        }).catch(function (err) {
          showToast(err.message, false);
        }).then(function () {
          btn.disabled = false; btn.innerHTML = orig;
        });
      });
    });
  }
})();